import { useFormikContext } from 'formik';
import { useEffect } from 'react';

interface Props {
  orderedFields: Array<string>;
}

export const scrollToErrors = (
  errorKeys: Array<string>,
  orderedFields: Array<string>,
  touched: Array<string>
) => {
  if (errorKeys.length > 0) {
    // Sort the errors array to match the visual order of the form fields
    errorKeys.sort((a, b) => {
      const aIndex = orderedFields.indexOf(a);
      const bIndex = orderedFields.indexOf(b);
      return aIndex - bIndex;
    });
    // Find and scroll to the topmost form error onSubmit
    const formError = document.getElementById(errorKeys[0]);
    // Set scroll location to be slightly above the form element
    let y = 0;
    const yOffset = -10;
    // Check if the formError element is hidden
    const formErrorStyles = window.getComputedStyle(formError);
    if (formErrorStyles.getPropertyValue('display') === 'none') {
      // Scroll to sibling of hidden form elements
      y =
        formError.previousElementSibling.getBoundingClientRect().top + yOffset;
    } else {
      y = formError.getBoundingClientRect().top + yOffset;
    }
    window.scrollBy({
      top: y,
      behavior: 'smooth',
    });
    requestAnimationFrame(() => {
      document.getElementById(errorKeys[0])?.focus();
    });
  } else if (touched.length === 0) {
    // Scroll to the topmost form field when no fields have been touched
    const topFormField = document.getElementById(orderedFields[0]);
    const y = topFormField.getBoundingClientRect().top - 10;
    window.scrollBy({
      top: y,
      behavior: 'smooth',
    });
  }
};

export const FocusFormikErrors = (props: Props): null => {
  const { orderedFields } = props;
  const { errors, touched, isSubmitting, isValid } = useFormikContext();

  useEffect(() => {
    if (!isSubmitting && !isValid) {
      // scroll to the first error
      scrollToErrors(Object.keys(errors), orderedFields, Object.keys(touched));
    }
  }, [isSubmitting]);
  // No UI, return null
  return null;
};
